import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import {
  Button,
  CardComponent,
  Check,
  DottedText,
  Eye,
  Folder,
  GeneralCardComponent,
  LeftArrow,
  Merge,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Loader from '../../_components/molecules/Loader';
import { observer } from 'mobx-react';
import Snackbar from '../../_components/atoms/Snackbar';
import contractAIQConstants from '../../core-utils/messages/ContractAIQConstants';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { useStores } from '../../stores';
import { useNavigate } from 'react-router-dom';
import {
  CONTRACT_AIQ_INTERNAL,
  CONTRACT_ONBOARDING,
} from '../../core-utils/routes';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { commonDropDownProps } from '../../_components/atoms/ReportsCohortItem';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import {
  extractAndSaveMetadataForContract,
  extractAndSaveProvisionMatrix,
  getUrlsForServiceAgreement,
} from '../../core-utils/helper-utils/contractMetadataHelper';
import {
  // createNamespace,
  extractReport,
} from '../../core-utils/helper-utils/contractReportHelper';
import {
  extractCompareAgreementDetails,
  formatMergePlanDocsData,
} from '../../core-utils/helper-utils/contractAIQHelper';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import MergeDocuments from '../../../public/Images/MergeDocs.png';

export interface contractMergeDocProps {}

const ContractMergeDocument: React.FC<contractMergeDocProps> = observer(
  ({}) => {
    //Constants
    const messages = contractAIQConstants;
    const navigate = useNavigate();
    const amendmentStatusValues =
      messages.COMPLIANCE_ASSURANCE.AMENDMENT_STATUS_OPTIONS;
    const amendmentStatusOptions = [
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Typography>Under Review</Typography>
        <Eye style={{ height: '24px', width: '24px' }} />
      </div>,
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Typography>Amendment Complete</Typography>
        <Check style={{ height: '30px', width: '30px' }} />
      </div>,
    ];

    //States
    const [loading, setLoading] = useState<boolean>(false);
    const [loader] = useState<any>(<Loader />);

    //Plan Documents Merger States
    const [isPlanDoc, setIsPlanDoc] = useState<boolean>(false);
    const [planId, setPlanId] = useState<string>('');
    const [planData, setPlanData] = useState<any>('');

    //Contracts Merger States
    const [contractId, setContractId] = useState<string>('');
    const [contractData, setContractData] = useState<any>('');

    //Documents States
    const [documents, setDocuments] = useState<any>('');
    const [baseDocs, setBaseDocs] = useState<any>('');
    const [amendments, setAmendments] = useState<any>('');
    const [baseDocloading, setBaseDocLoading] = useState<boolean>(false);
    const [baseDocDropdownvalue, setBaseDocDropdownValue] = useState<string>(
      '',
    );
    const [baseDocDropdownOptions, setBaseDocDropdownOptions] = useState<any>(
      [],
    );
    const [baseDocLatestVersion, setBaseDocLatestVersion] = useState<number>(0);
    const [baseDocEditorUrl, setBaseDocEditorUrl] = useState<string>('');
    const [amendmentDocloading, setAmendmentDocLoading] = useState<boolean>(
      false,
    );
    const [
      amendmentDocdropdownvalue,
      setAmendmentDocDropdownValue,
    ] = useState<string>('');
    const [
      amendmentDocdropDownOptions,
      setAmendmentDropdownOptions,
    ] = useState<any>([]);
    const [
      amendmentDropDownTooltip,
      setAmendmentDropDownTooltip,
    ] = useState<any>([]);
    const [amendmentDocEditorUrl, setAmendmentDocEditorUrl] = useState<string>(
      '',
    );
    const [
      amendmentStatusDropDownValue,
      setAmendmentStatusDropDownValue,
    ] = useState<string>('');
    const [disableMerge, setDisableMerge] = useState<boolean>(true);
    const [
      isDocumentNotConverted,
      setIsDocumentNotConverted,
    ] = useState<boolean>(false);

    //Stores
    const employerGroupStore = useStores().employerGroupStore;
    const contractStore = useStores().contractAiqStore;

    const useStyles = makeStyles()({
      mainDiv: {
        marginTop: '40px',
        width: '93%',
        marginLeft: '63px',
      },
      docContainer: {
        display: 'flex',
        gap: '20px',
        width: '100%',
      },
      container: {
        width: '100%',
        marginBottom: '27px',
        gap: '7px',
      },
    });

    const { classes } = useStyles();

    //Handle Functions
    const handleContractSelected = async () => {
      contractStore.setContractId(contractId);

      navigate(CONTRACT_AIQ_INTERNAL, {
        state: {
          contract: contractData.service_agreement_name,
          healthcarePartner: contractData.health_care_partner_name,
        },
      });
    };

    const handleBaseDocDropdownChange = async (value: string) => {
      const doc = baseDocs?.find((temp: any) => temp?._id === value);
      if (doc) {
        setBaseDocDropdownValue(value);
        setBaseDocLoading(true);
        doc.status === 'Draft' ? setDisableMerge(false) : setDisableMerge(true);
        getEditorUrl(doc, 'base');
      }
    };

    const handleAmendmentDocDropdownChange = async (value: string) => {
      const doc = amendments?.find((temp: any) => temp?._id === value);
      if (doc) {
        setAmendmentDocDropdownValue(value);
        setAmendmentStatusDropDownValue(doc.status);
        setAmendmentDocLoading(true);
        getEditorUrl(doc, 'amendment');
      }
    };

    const handleAmendmentStatusChange = async (value: string) => {
      const doc = amendments?.find(
        (temp: any) => temp?._id === amendmentDocdropdownvalue,
      );
      if (doc) {
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.contractBaseUrl +
              properties.mergeDoc,
            {
              document_version_id: doc?._id,
              status: value,
              isPlanDoc,
            },
          )
          .then((res) => {
            if (res.status === 200) {
              if (value === 'Amendment Complete') {
                const id = isPlanDoc
                  ? doc?.plan_document_id
                  : doc?.contract_document_id;
                exportPdf(doc?.document_url, id);
              }
              setAmendmentStatusDropDownValue(value);
              getDocumentVersions();
            }
          });
      }
    };

    const [snackbarState, setSnackbarState] = React.useState<{
      open: boolean;
      message: string;
      severity: MuiColor | undefined;
      duration: null | number;
    }>({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
    const handleOpenSnackBar = (
      message: string,
      severity: MuiColor,
      duration: number | null,
    ) => {
      setSnackbarState({
        open: true,
        message: message,
        severity: severity,
        duration: duration,
      });
    };
    const handleCloseSnackBar = (
      event?: React.SyntheticEvent,
      reason?: string,
    ) => {
      if (reason === 'clickaway') {
        return;
      }
      setSnackbarState({
        open: false,
        message: '',
        severity: undefined,
        duration: null,
      });
    };

    //Api calls
    const exportPdf = async (docUrl: any, id: any) => {
      const res = await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.exportPdf,
        {
          docUrl: docUrl,
          employer:
            employerGroupStore.employerGroupResponseData.employer_group_name[0],
          isPlanDoc,
          id: id,
        },
      );
      return res.data.data;
    };

    const mergeDocument = async () => {
      const doc = baseDocs.find(
        (temp: any) => temp?._id === baseDocDropdownvalue,
      );
      if (doc) {
        const isFinal = amendments.every(
          (amendment: any) => amendment.status === 'Amendment Complete',
        );
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.contractBaseUrl +
              properties.mergeDoc,
            {
              document_version_id: doc?._id,
              status: isFinal ? 'Final' : 'Merged',
              isFinal: isFinal,
              isPlanDoc,
            },
          )
          .then(async (res) => {
            if (res.status === 200) {
              getDocumentVersions();
              const docUrl = doc?.document_url;
              if (isFinal) {
                const id = isPlanDoc
                  ? doc?.plan_document_id
                  : doc?.contract_document_id;
                const pdfUrl = await exportPdf(docUrl, id);
                const egNid =
                  employerGroupStore.employerGroupResponseData.eg_nid[0];
                const employer =
                  employerGroupStore.employerGroupResponseData
                    .employer_group_name[0];
                if (!isPlanDoc) {
                  await extractAndSaveMetadataForContract(
                    egNid,
                    contractId,
                    contractData.service_agreement_name,
                    pdfUrl,
                    '',
                    getUrlsForServiceAgreement(
                      contractData?.service_agreement_name,
                      contractData?.features,
                    ),
                  );
                  if (contractData?.reports?.includes('Provision Matrix')) {
                    await extractAndSaveProvisionMatrix(
                      pdfUrl,
                      contractId,
                      egNid,
                      contractData.service_agreement_name,
                    );
                  }
                  // const namespace = doc?._id;
                  // await createNamespace(namespace, docUrl);
                  //After namespace creation wait for 5 secs
                  // await new Promise((resolve) => setTimeout(resolve, 5000));
                  await Promise.all(
                    contractData?.reports?.map(async (report: string) => {
                      const {
                        compareAgreementId,
                        compareUrl,
                      } = extractCompareAgreementDetails(contractData, report);

                      await extractReport(
                        contractId,
                        pdfUrl,
                        report,
                        egNid,
                        compareAgreementId,
                        compareUrl,
                        '',
                        false,
                        employer,
                      );
                    }),
                  );
                }
              }
            }
          });
      }
    };

    const getContracts = async () => {
      setLoading(true);
      await axios
        .post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getContracts,
          {
            eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
          },
        )
        .then((res: any) => {
          if (res.status === 200) {
            const data = res?.data?.data.find(
              (temp: any) => temp.contract_id === contractId,
            );
            if (!data?.is_document_converted) {
              setIsDocumentNotConverted(true);
            }
            setContractData(data);
            setLoading(false);
          }
        })
        .catch((error) => {
          handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
        });
    };

    const getPlanDocs = async () => {
      await axios
        .post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getPlanDocs,
          {
            eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
          },
        )
        .then(async (res: any) => {
          if (res.status === 200) {
            const data = formatMergePlanDocsData(res?.data?.data);
            const plan = data.data?.find(
              (temp: any) => temp.plan_id === planId,
            );
            if (!plan?.is_document_converted) {
              setIsDocumentNotConverted(true);
            }
            setPlanData(plan);
            setLoading(false);
          }
        })
        .catch((error) => {
          handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
        });
    };

    const getDocumentVersions = async () => {
      setLoading(true);
      const reqbody = isPlanDoc
        ? {
            planId: planId,
          }
        : {
            contractId: contractId,
          };

      await axios
        .post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getDocVersions,
          reqbody,
        )
        .then((res: any) => {
          if (res.status === 200) {
            setDocuments(res?.data?.data);
            setLoading(false);
          }
        })
        .catch((error) => {
          handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
        });
    };

    const getEditorUrl = async (doc: any, type: string) => {
      try {
        let version = 0;
        if (
          doc.document_type === 'Base Document' ||
          (doc.document_type === 'Master Document' && doc.status !== 'Draft')
        ) {
          version = baseDocLatestVersion + 1;
        } else if (
          doc.document_type === 'Amendment' &&
          doc.status === 'Amendment Complete'
        ) {
          version = doc.version + 1;
        } else {
          version = doc.version;
        }
        const getDocResponse = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getDocUrl,
          {
            docUrl: doc?.document_url,
            documentName: doc.document_name,
            documentId: isPlanDoc
              ? doc.plan_document_id
              : doc.contract_document_id,
            id: isPlanDoc ? planId : contractId,
            version: version,
            documentType: doc.document_type,
            employer:
              employerGroupStore.employerGroupResponseData
                .employer_group_name[0],
            isPlanDoc: isPlanDoc,
          },
        );
        if (type === 'base') {
          setBaseDocEditorUrl(getDocResponse.data.data.editorUrl);
          setBaseDocLoading(false);
        }
        if (type === 'amendment') {
          setAmendmentDocEditorUrl(getDocResponse.data.data.editorUrl);
          setAmendmentDocLoading(false);
        }
      } catch (error: any) {
        handleOpenSnackBar(
          error.response?.data?.error || 'Error occurred',
          'error',
          6000,
        );
      }
    };

    //UseEffects
    useEffect(() => {
      if (baseDocs !== '') {
        const baseDocTypeCounts = baseDocs.reduce((acc: any, doc: any) => {
          acc[doc.document_type] = (acc[doc.document_type] || 0) + 1;
          return acc;
        }, {});
        const baseDocDropDownOptions = baseDocs.map(
          (doc: any, index: number) => {
            const docTypeCount = baseDocTypeCounts[doc.document_type];
            const docTypeLabel =
              docTypeCount > 1
                ? `${doc.document_type} ${index + 1}`
                : doc.document_type;

            return docTypeLabel === 'Base Document'
              ? docTypeLabel
              : `${docTypeLabel} (${doc.status})`;
          },
        );
        setBaseDocDropdownOptions(baseDocDropDownOptions);
        baseDocDropdownvalue !== ''
          ? ''
          : setBaseDocDropdownValue(baseDocs[0]?._id);
        const id =
          baseDocDropdownvalue !== '' ? baseDocDropdownvalue : baseDocs[0]?._id;
        const doc = baseDocs.find((temp: any) => temp?._id === id);
        if (doc) {
          getEditorUrl(doc, 'base');
          doc.status === 'Draft'
            ? setDisableMerge(false)
            : setDisableMerge(true);
        }
      }
    }, [baseDocs]);

    useEffect(() => {
      if (amendments !== '') {
        const tooltips: String[] = [];
        const amendmentDropDownOptions = amendments.map((doc: any) => {
          tooltips.push(doc.document_name);
          const updatedLabel =
            doc.status === 'Amendment Complete' ? (
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <Typography>{doc.document_name.slice(0, 17)}...</Typography>
                <Check style={{ height: '30px', width: '30px' }} />
              </div>
            ) : (
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <Typography>{doc.document_name.slice(0, 17)}...</Typography>
                <Eye style={{ height: '24px', width: '24px' }} />
              </div>
            );

          return updatedLabel;
        });
        setAmendmentDropDownTooltip(tooltips);
        setAmendmentDropdownOptions(amendmentDropDownOptions);
        const id =
          amendmentDocdropdownvalue !== ''
            ? amendmentDocdropdownvalue
            : amendments[0]?._id;
        setAmendmentDocDropdownValue(id);
        const doc = amendments.find((temp: any) => temp?._id === id);
        if (doc) {
          getEditorUrl(doc, 'amendment');
          setAmendmentStatusDropDownValue(doc?.status);
        }
      }
    }, [amendments]);

    useEffect(() => {
      if (documents !== '') {
        const base = documents
          .filter((temp: any) => temp.document_type !== 'Amendment')
          .sort((a: any, b: any) => {
            const order = ['Final', 'Merged', 'Draft', 'Previously Merged'];
            return order.indexOf(a.status) - order.indexOf(b.status);
          });
        const baseDocLatestVersion = base.reduce(
          (maxVersion: any, currentDoc: any) =>
            currentDoc.version > maxVersion ? currentDoc.version : maxVersion,
          0,
        );
        setBaseDocLatestVersion(baseDocLatestVersion);
        setBaseDocs(base);

        const latestAmendments = documents
          .filter((doc: any) => doc.document_type === 'Amendment') // Filter by document type 'Amendment'
          .reduce((acc: any, currentDoc: any) => {
            if (isPlanDoc) {
              const { plan_document_id, version } = currentDoc;
              if (
                !acc[plan_document_id] ||
                acc[plan_document_id].version < version
              ) {
                acc[plan_document_id] = currentDoc;
              }
              return acc;
            } else {
              const { contract_document_id, version } = currentDoc;
              // Check if the contract_document_id is already present in the accumulator
              if (
                !acc[contract_document_id] ||
                acc[contract_document_id].version < version
              ) {
                // If not present or if the current document version is higher, update it
                acc[contract_document_id] = currentDoc;
              }
              return acc;
            }
          }, {});
        const latestAmendmentDocs = Object.values(latestAmendments);
        setAmendments(latestAmendmentDocs);
      }
    }, [documents]);

    useEffect(() => {
      if (contractId === '' && planId === '') {
        return;
      }
      isPlanDoc ? getPlanDocs() : getContracts();
      getDocumentVersions();
      const socket = new WebSocket(process.env.WEBSOCKET_URL ?? '');
      socket.onopen = () => {
        console.log('WebSocket connection established');
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data?.status === 'Websocket Established') {
          console.log(data?.status);
        }
        if (data?.status === 'document_saved') {
          data?.docType === 'Amendment'
            ? setAmendmentDocDropdownValue(data?.docId)
            : setBaseDocDropdownValue(data?.docId);
          getDocumentVersions();
        }
      };
      socket.onclose = () => {
        // eslint-disable-next-line no-console
        console.log('WebSocket connection closed');
      };
      socket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };
    }, [contractId, planId]);

    useEffect(() => {
      setBaseDocLoading(true);
      setAmendmentDocLoading(true);
      const isPlanDocc = contractStore.planId !== '';
      setIsPlanDoc(isPlanDocc);
      isPlanDocc
        ? setPlanId(contractStore.planId)
        : setContractId(contractStore.contractId);
    }, []);

    //Components
    const MergeDocument = () => {
      return (
        <Grid className={classes.docContainer}>
          <CardComponent
            title={''}
            body={
              <Grid container style={{ marginTop: '10px' }}>
                {baseDocloading ? (
                  loader
                ) : baseDocEditorUrl !== '' ? (
                  <iframe
                    src={baseDocEditorUrl}
                    width="100%"
                    height="600px"
                    title="Editor"
                  ></iframe>
                ) : (
                  <p>Loading Editor...</p>
                )}
              </Grid>
            }
            dropdownElement={
              baseDocs.length > 0 ? (
                <Dropdown
                  label={'Select'}
                  dropDownOptions={baseDocDropdownOptions}
                  dropDownValues={baseDocs?.map((temp: any) => temp?._id)}
                  value={baseDocDropdownvalue}
                  handleChange={(e) =>
                    handleBaseDocDropdownChange(e.target.value as string)
                  }
                  selectStyles={{
                    ...commonDropDownProps.selectStyles,
                    width: '340px',
                  }}
                />
              ) : (
                <></>
              )
            }
            topRightItem={
              <Button
                label={messages.COMPLIANCE_ASSURANCE.MERGE}
                endIcon={<Merge />}
                variant="contained"
                style={{ width: '100px' }}
                onClick={mergeDocument}
                disabled={disableMerge}
              />
            }
            mainGridStyles={{
              width: '50%',
              marginTop: '25px',
              marginBottom: '25px',
            }}
          />
          <CardComponent
            title={''}
            body={
              <Grid container style={{ marginTop: '10px' }}>
                {amendmentDocloading ? (
                  loader
                ) : amendmentDocEditorUrl !== '' ? (
                  <iframe
                    src={amendmentDocEditorUrl}
                    width="100%"
                    height="600px"
                    title="Editor"
                  ></iframe>
                ) : (
                  <p>Loading Editor...</p>
                )}
              </Grid>
            }
            dropdownElement={
              amendments.length > 0 ? (
                <Dropdown
                  label={'Select'}
                  dropDownOptions={amendmentDocdropDownOptions}
                  tooltipValues={amendmentDropDownTooltip}
                  isTooltip={true}
                  dropDownValues={amendments?.map((temp: any) => temp._id)}
                  value={amendmentDocdropdownvalue}
                  handleChange={(e) =>
                    handleAmendmentDocDropdownChange(e.target.value as string)
                  }
                  selectStyles={{
                    ...commonDropDownProps.selectStyles,
                    width: '250px',
                  }}
                />
              ) : (
                <></>
              )
            }
            topRightItem={
              <Dropdown
                label={'Select'}
                dropDownOptions={amendmentStatusOptions}
                dropDownValues={amendmentStatusValues}
                value={amendmentStatusDropDownValue}
                handleChange={(e) =>
                  handleAmendmentStatusChange(e.target.value as string)
                }
                selectStyles={{
                  ...commonDropDownProps.selectStyles,
                  width: '250px',
                }}
              />
            }
            mainGridStyles={{
              width: '50%',
              marginTop: '25px',
              marginBottom: '25px',
            }}
          />
        </Grid>
      );
    };

    return (
      <>
        {loading ? (
          loader
        ) : (
          <>
            <Box className={classes.mainDiv}>
              <Box className={classes.container}>
                <PageTitleAndSubTitle
                  title={messages.COMPLIANCE_ASSURANCE.MERGE_DOCS_TITLE}
                  subTitle={messages.COMPLIANCE_ASSURANCE.MERGE_DOCS_SUBTITLE}
                  showDownloadButton={false}
                  showQueryDataButton={false}
                />
              </Box>
              <Grid
                container
                className={classes.container}
                onClick={() =>
                  navigate(CONTRACT_ONBOARDING, { state: { tabIndex: 1 } })
                }
                sx={{
                  alignItems: 'center',
                }}
              >
                <LeftArrow style={{ cursor: 'pointer' }} />
                <DottedText
                  text={
                    isPlanDoc
                      ? messages.COMPLIANCE_ASSURANCE.BACK_TO_PLAN_DOCUMENTS
                      : messages.COMPLIANCE_ASSURANCE.BACK_TO_CONTRACTS
                  }
                />
              </Grid>
              {contractData && (
                <Grid
                  container
                  className={classes.container}
                  style={{ gap: '30px' }}
                >
                  <GeneralCardComponent
                    title={messages.COMPLIANCE_ASSURANCE.CONTRACT_LABELS[1]}
                    body={
                      <Grid
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '7px',
                        }}
                        onClick={handleContractSelected}
                      >
                        <Folder style={{ width: '24px', height: '24px' }} />
                        <DottedText
                          text={contractData.health_care_partner_name}
                        />
                      </Grid>
                    }
                    headerStyles={{ padding: '16px' }}
                    bodyStyles={{ padding: '16px' }}
                    width="32%"
                  />
                  <GeneralCardComponent
                    title={messages.COMPLIANCE_ASSURANCE.CONTRACT_LABELS[4]}
                    body={
                      <Typography
                        fontSize="14px"
                        fontType="semiBold"
                        lineHeight="24px"
                        textColor={patientAccessTheme.palette.text.highemphasis}
                        margin="0px 8px 0px 0px"
                      >
                        {contractData.service_agreement_name}
                      </Typography>
                    }
                    headerStyles={{ padding: '16px' }}
                    bodyStyles={{ padding: '16px' }}
                    width="32%"
                  />
                  <GeneralCardComponent
                    title={messages.COMPLIANCE_ASSURANCE.CONTRACT_LABELS[2]}
                    body={
                      <Typography
                        fontSize="14px"
                        fontType="semiBold"
                        lineHeight="24px"
                        textColor={patientAccessTheme.palette.text.highemphasis}
                        margin="0px 8px 0px 0px"
                      >
                        {contractData.type}
                      </Typography>
                    }
                    headerStyles={{ padding: '16px' }}
                    bodyStyles={{ padding: '16px' }}
                    width="32%"
                  />
                </Grid>
              )}
              {planData && (
                <Grid
                  container
                  className={classes.container}
                  style={{ gap: '30px' }}
                >
                  <GeneralCardComponent
                    title={messages.COMPLIANCE_ASSURANCE.PLAN_DOCS_LABELS[1]}
                    body={
                      <Grid
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '7px',
                        }}
                      >
                        <Folder style={{ width: '24px', height: '24px' }} />
                        <Typography
                          fontSize="14px"
                          fontType="semiBold"
                          lineHeight="24px"
                          textColor={
                            patientAccessTheme.palette.text.highemphasis
                          }
                          margin="0px 8px 0px 0px"
                        >
                          {planData.type}
                        </Typography>
                      </Grid>
                    }
                    headerStyles={{ padding: '16px' }}
                    bodyStyles={{ padding: '16px' }}
                    width="32%"
                  />
                  <GeneralCardComponent
                    title={messages.COMPLIANCE_ASSURANCE.PLAN_DOCS_LABELS[0]}
                    body={
                      <Typography
                        fontSize="14px"
                        fontType="semiBold"
                        lineHeight="24px"
                        textColor={patientAccessTheme.palette.text.highemphasis}
                        margin="0px 8px 0px 0px"
                      >
                        {planData.name}
                      </Typography>
                    }
                    headerStyles={{ padding: '16px' }}
                    bodyStyles={{ padding: '16px' }}
                    width="32%"
                  />
                  <GeneralCardComponent
                    title={messages.COMPLIANCE_ASSURANCE.CONTRACT_LABELS[2]}
                    body={
                      <Typography
                        fontSize="14px"
                        fontType="semiBold"
                        lineHeight="24px"
                        textColor={patientAccessTheme.palette.text.highemphasis}
                        margin="0px 8px 0px 0px"
                      >
                        {planData.document_type}
                      </Typography>
                    }
                    headerStyles={{ padding: '16px' }}
                    bodyStyles={{ padding: '16px' }}
                    width="32%"
                  />
                </Grid>
              )}
              {!isDocumentNotConverted && documents.length > 0 && (
                <MergeDocument />
              )}
              {isDocumentNotConverted && (
                <Grid style={{ height: '400px' }}>
                  <GifWithLabels
                    rootStyles={{
                      height: '400px',
                    }}
                    mainLabel={
                      <Typography
                        fontSize="16px"
                        fontType="medium"
                        lineHeight="22.4px"
                        textColor={patientAccessTheme.palette.text.highemphasis}
                        margin="0px 0px 20px 0px"
                      >
                        Documents are being processed, please come again in some
                        time
                      </Typography>
                    }
                    gifUrl={MergeDocuments}
                    subLabel={''}
                  />
                </Grid>
              )}
            </Box>
            <Snackbar
              {...snackbarState}
              handleClose={handleCloseSnackBar}
              vertical="bottom"
              horizontal="right"
            />
          </>
        )}
      </>
    );
  },
);
export default ContractMergeDocument;
